import DynamicTable from "../../../components/DynamicTable";
import FilterMenu from "./FilterMenu";
import { Col, message } from "antd";
import API from "../../../services/api-request";
import React, { useEffect, useState } from "react";
import state from "../../../../src/config/valtio/store";
import {
  Button,
  Flex,
  Tooltip,
  Modal,
  Row,
  Menu,
  Dropdown,
  Input,
  AutoComplete,
} from "antd";
import {
  BarChartOutlined,
  HistoryOutlined,
  // EditOutlined,
  DownOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { getDataLogin } from "../../../utils/getDataLogin";
import { appName } from "../../../config/url-config";

const ListCard = () => {
  var currentDate = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();

  const handleRedirect = (id, tabs) => {
    navigate(
      `/detail-card?tabs=${tabs}&id=${id}&strDate=${currentDate}&endDate=${currentDate}`
    );
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [dataCard, setDataCard] = useState([]);
  const [dataGC, setDataGC] = useState([]);

  const [selectedDatas, setSelectedDatas] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");

  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const showModalGroup = () => {
    setOpenGroup(true);
  };
  const onSelecteGroup = (e) => {
    setSelectedGroup(e);
  };

  const handleOk = () => {
    if (selectedGroup) {
      setConfirmLoading(true);
      updateGroup(selectedGroup);
    } else {
      message.info("select group is required");
    }
  };

  const updateGroup = async (group) => {
    let cardId = [];

    selectedDatas.forEach((data) => {
      cardId.push(data.id);
    });

    const dataClient = {
      id: cardId,
      client: group,
    };
    const dataGroup = {
      id: cardId,
      group: group,
    };

    await API.Post(
      `card/bulk-update`,
      getDataLogin().privilege.generale_role === "admin"
        ? dataClient
        : dataGroup
    )
      .then((result) => {
        setOpen(false);
        setOpenGroup(false);
        setConfirmLoading(false);
        setSelectedGroup("");
        setSelectedDatas([]);
        getDataCard();
        getDataGroup();
        message.success(result.data.message);
      })
      .catch((err) => {
        message.info("Failed Change Group!");
      });
  };

  const handleCancel = () => {
    setOpen(false);
    setOpenGroup(false);
  };

  const onSelectedDatas = (val) => {
    setSelectedDatas(val);
  };

  const getDataCard = async (
    status = searchParams.get("status") ?? "",
    session = searchParams.get("session") ?? "",
    search = searchParams.get("search") ?? ""
  ) => {
    state.LOADING = true;

    await API.Get(
      `card?billing_status=${status}&session=${session}&search=${search}`
    )
      .then((result) => {
        setDataCard(result.data);
      })
      .catch((err) => {
        setDataCard([]);
        message.info("Failed Fetch Cards Data!");
      });

    state.LOADING = false;
  };

  const getDataGroup = async () => {
    await API.Get(`group`)
      .then((result) => {
        let dataTemp = [];

        result.data.forEach((data) => {
          dataTemp.push({ value: data.name });
        });

        setDataGC(dataTemp);
      })
      .catch((err) => {
        setDataGC([]);
        message.info("Failed Fetch Groups Data!");
      });
  };

  const getDataClient = async () => {
    await API.Get(`client`)
      .then((result) => {
        let dataTemp = [];

        result.data.forEach((data) => {
          dataTemp.push({ value: data.name });
        });

        setDataGC(dataTemp);
      })
      .catch((err) => {
        setDataGC([]);
        message.info("Failed Fetch Client Data!");
      });
  };

  const handleQuery = (values) => {
    let status = "";
    let session = "";
    let search = "";

    if (values) {
      status = values.status ?? "";
      session = values.session ?? "";
      search = values.search ?? "";
    }

    getDataCard(
      status === "ALL-STATUS" ? "" : status,
      session === "ALL-SESSION" ? "" : session,
      search
    );
  };

  useEffect(() => {
    getDataCard();
    if (getDataLogin().privilege.generale_role === "admin") {
      getDataClient();
    } else {
      getDataGroup();
    }

    document.title = `SIM Card | ${appName}`;
    // eslint-disable-next-line
  }, []);

  const column = [
    {
      title: "MSISDN",
      dataIndex: "msisdn",
      key: "msisdn",
      width: 140,
      fixed: "left",
      sorter: (a, b) => a.msisdn - b.msisdn,
      render: (msisdn) => {
        if (msisdn === null || msisdn === "") {
          return "-";
        } else {
          return msisdn;
        }
      },
    },
    {
      title: "Serial Number",
      dataIndex: "imsi",
      key: "imsi",
      width: 180,
      sorter: (a, b) => a.imsi - b.imsi,
      render: (imsi) => {
        if (imsi === null || imsi === "") {
          return "-";
        } else {
          return imsi;
        }
      },
    },
    {
      title: "Data Session",
      dataIndex: "",
      key: "x",
      width: 180,
      render: (data) => {
        if (data.session === null || data.session === "") {
          return "-";
        } else {
          return (
            <Row justify={"space-between"} align={"middle"}>
              <div
                style={{
                  color: data.session === "ONLINE" ? "#08b95e" : "#000",
                }}
              >
                {data.session === "ONLINE" ? <WifiOutlined /> : null}{" "}
                {data.session}
              </div>
              <Tooltip title="history">
                <Button
                  icon={<HistoryOutlined />}
                  onClick={(e) => handleRedirect(data.id, "1")}
                />
              </Tooltip>
            </Row>
          );
        }
      },
    },
    // {
    //   title: "RAT Type",
    //   dataIndex: "rat_type",
    //   key: "rat_type",
    //   width: 150,
    //   sorter: (a, b) => a.rat_type - b.rat_type,
    //   render: (rat_type) => {
    //     if (rat_type === null || rat_type === "") {
    //       return "null";
    //     } else {
    //       return rat_type;
    //     }
    //   },
    // },
    {
      title: "Data Consume",
      dataIndex: "",
      key: "x",
      width: 180,
      render: (data) => {
        if (data.data_usage === null || data.data_usage === "") {
          return "-";
        } else {
          return (
            <Row justify={"space-between"} align={"middle"}>
              <div>{data.data_usage}</div>
              <Tooltip title="usage">
                <Button
                  icon={<BarChartOutlined />}
                  onClick={(e) => handleRedirect(data.id, "2")}
                />
              </Tooltip>
            </Row>
          );
        }
      },
    },
    {
      title: "Client",
      dataIndex: "",
      key: "x",
      width: 250,
      render: (data) => {
        if (data.client.name === null || data.client.name === "") {
          return "-";
        } else {
          return (
            <Row justify={"space-between"} align={"middle"}>
              <div>{data.client.name}</div>
              {/* <Tooltip title="history">
                <Button icon={<EditOutlined />} onClick={showModalGroup} />
              </Tooltip> */}
            </Row>
          );
        }
      },
    },
    {
      title: "Group",
      dataIndex: "",
      key: "x",
      width: 250,
      render: (data) => {
        if (data.group.name === null || data.group.name === "") {
          return "-";
        } else {
          return (
            <Row justify={"space-between"} align={"middle"}>
              <div>{data.group.name}</div>
              {/* <Tooltip title="history">
                <Button icon={<EditOutlined />} onClick={showModalGroup} />
              </Tooltip> */}
            </Row>
          );
        }
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: 120,
      sorter: (a, b) => a.country - b.country,
      render: (country) => {
        if (country === null || country === "") {
          return "-";
        } else {
          return country;
        }
      },
    },
    {
      title: "Activation Date",
      dataIndex: "activation_date",
      key: "activation_date",
      width: 180,
      sorter: (a, b) => a.activation_date - b.activation_date,
      render: (activation_date) => {
        if (activation_date === null || activation_date === "") {
          return "-";
        } else {
          return activation_date;
        }
      },
    },
    {
      title: "APN & Static IP",
      dataIndex: "apn_static_ip",
      key: "apn_static_ip",
      width: 180,
      sorter: (a, b) => a.apn_static_ip - b.apn_static_ip,
      render: (apn_static_ip) => {
        if (apn_static_ip === null || apn_static_ip === "") {
          return "-";
        } else {
          return apn_static_ip;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "billing_status",
      key: "billing_status",
      width: 180,
      sorter: (a, b) => a.billing_status - b.billing_status,
      render: (billing_status) => {
        if (billing_status === null || billing_status === "") {
          return "-";
        } else {
          return billing_status;
        }
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      width: 120,
      render: (data) => (
        <Flex wrap gap="small">
          <Tooltip title="deactive">
            <Button type="primary" danger onClick={showModal}>
              Deactive
            </Button>
          </Tooltip>
        </Flex>
      ),
    },
  ];

  const handleMenuClick = (e) => {
    const selectedItem = items.find((item) => item.key === e.key);
    if (selectedItem.key === "1") {
      showModalGroup();
    }
    if (selectedItem.key === "2") {
      showModal();
    }
  };

  const items = [
    {
      key: "2",
      label: "Active/Deactive",
    },
  ];

  items.splice(0, 0, {
    key: "1",
    label:
      getDataLogin().privilege.generale_role === "admin" ? "Client" : "Group",
  });

  const menu = () => {
    return (
      <Menu onClick={handleMenuClick}>
        {items.map((item) => (
          <Menu.Item key={item.key}>{item.label}</Menu.Item>
        ))}
      </Menu>
    );
  };

  // const options = [
  //   {
  //     value: "PT JNE INDONESIA",
  //   },
  //   {
  //     value: "PT JNT INDONESIA",
  //   },
  //   {
  //     value: "PT FEDEX INDONESIA",
  //   },
  // ];

  return (
    <>
      <h2>SIM Card</h2>
      <hr />
      <br />
      {/* Filter Menu */}
      <FilterMenu onGetQuery={handleQuery} />

      <Modal
        title="Confirm"
        okText="Save"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{`Apakah anda akan menonaktifkan ${
          selectedDatas.length > 0 ? selectedDatas.length : ""
        } kartu ini?`}</p>
      </Modal>

      <Modal
        title={
          getDataLogin().privilege.generale_role === "admin"
            ? "Change Client"
            : "Change Group"
        }
        okText="Save"
        open={openGroup}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{`Apakah anda akan mengubah ${
          selectedDatas.length > 0 ? selectedDatas.length : ""
        } kartu ini?`}</p>
        <AutoComplete
          style={{
            width: 200,
          }}
          value={selectedGroup}
          options={dataGC}
          placeholder={
            getDataLogin().privilege.generale_role === "admin"
              ? "Select Client"
              : "Select Group"
          }
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onChange={onSelecteGroup}
        />
        <p style={{ fontSize: 9, color: "#B0B0B0" }}>
          *Jika tidak terdaftar, cukup tuliskan dan tekan Save.
        </p>
      </Modal>

      <Row
        gutter={[16, 16]}
        style={{ marginBottom: 16, marginTop: 16 }}
        align={"middle"}
      >
        <Col>
          <div style={{ fontWeight: 600 }}>Operations : </div>
        </Col>
        <Col xs={24} md={7} lg={4}>
          <Dropdown overlay={menu("status")} trigger={["click"]}>
            <Input
              readOnly
              value={"Select Action"}
              suffix={<DownOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
              placeholder="Select Action"
              style={{ cursor: "pointer" }}
              disabled={selectedDatas.length > 0 ? false : true}
            />
          </Dropdown>
        </Col>
        <Col>
          {selectedDatas.length > 0 ? (
            <span>{`${selectedDatas.length} Item Selected`}</span>
          ) : null}
        </Col>
      </Row>

      {/* List Card Table */}
      <DynamicTable
        data={dataCard}
        columns={column}
        useCheck={true}
        selectedDatas={selectedDatas}
        onSelectedDatas={onSelectedDatas}
      />
    </>
  );
};

export default ListCard;
